module.exports = __webpack_public_path__ + "img/psychiatry.d12938f7.svg";